import { render } from "./SensorWidget.vue?vue&type=template&id=54b4798e&scoped=true"
import script from "./SensorWidget.vue?vue&type=script&lang=js"
export * from "./SensorWidget.vue?vue&type=script&lang=js"

import "./SensorWidget.vue?vue&type=style&index=0&id=54b4798e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-54b4798e"

export default script